// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6d796464","197":"f7bf3637","375":"6b204ffe","416":"d88c633a","538":"e6b41258","545":"c50e5ba8","768":"fd059c0d"}[chunkId] + ".chunk.js";
};